 
 /* eslint-disable indent */
import React from 'react';
import Modal from 'react-modal';
import helper from '../../helpers';
import './index.scss';

Modal.setAppElement('#root');

class Layover extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.state={
      name:'',
      phone:'',
      nameandphone:'',
      description:'',
      error:false,
      errorMessage:'Please enter valid name and/or phone number'
    }
  }

  componentDidMount(){
    const {name, phone} = this.props;
    this.setState({
       nameandphone:(name)?name+', '+phone:phone,
       name:(name)?name:'',
       phone:phone
    })
  }
  componentWillReceiveProps(nextProps){
    if(nextProps.errorData.errorReportSucess && !nextProps.errorData.postErrorReport){
      this.setState({
        name:'',
        phone:'',
        nameandphone:'',
        description:'',
        error:false,
      })
    }
  }
  closeModal() {
    this.props.setreportOverlayVisibility(false);
    this.props.clearReportFlags();
    this.setState({
      name:'',
      phone:'',
      nameandphone:'',
      description:'',
      error:false,
    })
  }

  sendReport = () =>{
      const {selectedConversation, auth , business, erorReport,globalReport, selectedLocation} =this.props;
      const { studio_id } = auth;
      const bzid = this.props.business.id||studio_id;
      let params = {
      businessId: selectedLocation.studioId||bzid,
      userId:(globalReport)?"":selectedConversation.userId,
      name:this.state.name,
      number:this.state.phone,
      sessionId:(globalReport)?"":selectedConversation.id,
      description:this.state.description,
      email:business.info.EMAIL
    }
    this.props.erorReport(params);
  }

  handleChange = (event,key)=>{
      if(key === 'description'){
        this.setState({
          [key]:event.target.value
        });
      }else{
          let data = event.target.value.split(',');
          let name,phone;
          let error =false;
          let Nameregex = new RegExp(/^[a-zA-Z ]*$/);
          if(data.length<2){
            name = Nameregex.test(data[0])? data[0].trim():'';
            phone = helper.validatePhoneNumber(data[0])?data[0].trim():'';
            if(Nameregex.test(data[0]) || helper.validatePhoneNumber(data[0])){
              error = false;
            }else{
              error =true;
            }
          } else{
            name = Nameregex.test(data[0])? data[0]:'';
            phone = helper.validatePhoneNumber(data[1])?data[1].trim():'';
            if(!helper.validatePhoneNumber(data[1])){
              error = true;
            }
          }
          if((name+phone).length === 0){
            error = true;
          }
        this.setState({
          name: name,
          phone: phone,
          error:error,
          [key]:event.target.value
        })
    }
  }
  sendButtonStatus =()=>{
    const {nameandphone, description}= this.state;
    const { errorData } = this.props;
    if(nameandphone){
    if(nameandphone.trim().length>0 && description.trim().length>0 && !this.state.error){
        return ( errorData && errorData.postErrorReport)?true:false;
    }else{
      return true;
    }}else{
      return true;
    }
  }

  render() {
    const {modelopen,errorData, business,  typeofUser} = this.props;
    const {error, errorMessage} = this.state;
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          className="Modal"
          overlayClassName="overlay-top"
          contentLabel="Example Modal"
        >
          <div>
            {(!errorData.errorReportSucess ) &&
            <div className="modal-header">
              <div className="title">Report an issue</div>
              <button className="modal-close" onClick={this.closeModal}>X</button>
              <div className="sub-title">Let us know what happened and we’ll try to solve it as soon as possible.</div>
              <div className="input">
                <label className="label">{typeofUser} name and/or phone number *</label>
                <input type="text" className={error?'error-input':''} value={this.state.nameandphone} onChange={(event)=>this.handleChange(event,'nameandphone')} maxlength="100"/>
                {error && <div className="error-message">{errorMessage}</div>}
              </div>
              <div className="input">
                <label className="label">Describe your issue *</label>
                <textarea 
                    placeholder="Add brief description here"
                    value={this.state.description} 
                    onChange={(event)=>this.handleChange(event,'description')} 
                    className="description"
                />
              </div>
              <div className="actions">
                  <button className="btn btn--primary btn--lg" onClick={this.sendReport} disabled={this.sendButtonStatus()}>
                    {(errorData && errorData.postErrorReport) ?'Sending...':'SEND     '}
                    </button>
                  <button className="btn btn--secondary btn--lg" onClick={this.closeModal}>CANCEL</button>
              </div>
            </div>}
            {(errorData.errorReportSucess && !errorData.postErrorReport ) &&
              <div className="modal-header">
              <div className="title">Thank you.</div>
              <button className="modal-close" onClick={this.closeModal}>X</button>
              <div className="sub-title">We received your report and an email 
                confirmation has been sent to  <span className="email">{business.info.EMAIL}</span> 
              Customer success team will be in touch with you soon.
              </div>
              <div className="actions">
                  <button className="btn btn--primary btn--lg" onClick={this.closeModal}>
                    OK
                    </button>
              </div>
            </div>
            } 
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default Layover;

